"use client";
import {useRouter} from "next/navigation";
import {useState, useEffect} from "react";
import { FontIcon } from "@/app/_components";
import PayList from "./payList";
import $http from "@/app/_api";
import {useUser} from "@/app/context/UserContext";
import {GetUserLatestOrdersResponse} from "@/app/_api/types/store";
import styles from "./page.module.css";

export default function PayRecordsUI() {
    const router = useRouter();
    const [dataList, setDataList] = useState<GetUserLatestOrdersResponse>([] as GetUserLatestOrdersResponse);
    const user = useUser();

    useEffect(() => {
        getData();
    }, []);

    const getData: () => void = async () => {
        const data = await $http.Store.getUserLatestOrder({userId: user.userId});
        data.length && setDataList(data);
    }

    return (
        <div className={styles.page}>
            {/*<div className={styles.goBack} onClick={() => router.back()}>*/}
            {/*    <FontIcon item="s-back"/>*/}
            {/*</div>*/}

            {/*<div className={styles.header}>RECHARGE HISTORY</div>*/}

            <div className={styles.tips}>Only show the last 10 records</div>

            {dataList.length === 0 && <div className={styles.empty}>No data...</div>}

            {dataList.length > 0 && <PayList dataSource={dataList}/>}
        </div>
    )
}